import React from 'react'

export default ({label, value}) => (
  <div className='scoreboardText'>{label}: {value}</div>
)



// WEBPACK FOOTER //
// ./src/components/ScoreboardText.jsx